import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { PostList } from "../components/Posts";
import { getUser } from "../api";

export default function Feed() {
  const { t } = useTranslation();
  const nav = useNavigate();
  // La Home del professionista e' la propria pagina profilo (dove pubblica i post):
  // se apre manualmente /feed viene reindirizzato in sicurezza, senza loop.
  useEffect(() => {
    const u = getUser();
    if (u?.role === "professional") nav(`/professionals/${u.id}`, { replace: true });
  }, []);
  // Matrice Feed: nessun compositore nel Feed generale.
  // Professionisti/strutture pubblicano solo dalla propria pagina profilo; i pazienti non pubblicano.
  return (<Layout><div className="yp-container max-w-2xl py-8" data-testid="feed-page">
    <h1 className="text-3xl font-bold mb-4">{t("nav.feed")}</h1>
    <PostList />
  </div></Layout>);
}
